
import React from 'react'
import { LoadingSpinner } from '@paypalcorp/pp-react'
import PropTypes from 'prop-types'

const Spinner = ({fullScreen, ...props}) => {
  return (
    <div className={`dev_dash__loading--wrapper ${fullScreen ? "full-screen" :""}`}>
      <div className="loading--overlay" />
      <LoadingSpinner className="spinner" screenReaderText="loading" {...props} />
    </div>
  )
}

Spinner.propTypes = {
    fullScreen: PropTypes.bool,
}

export default Spinner